export type LOCATION_ID = string | number;
import { CLIENT_ID } from './client.model';
import { Event, EVENT_ID } from './event.model';
export class Location {
  id: LOCATION_ID;
  client_id: CLIENT_ID;
  event_id?: EVENT_ID;
  name: string;
  display_name?: string;
  description: string;
  address: string;
  entrances?: number;
  lat: number;
  lon: number;
  event?: Event;
}

export class CreateLocationInput {
  client_id: CLIENT_ID = NaN;
  name: string = '';
  display_name: string = '';
  description: string = '';
  address: string = '';
  entrances: number = NaN;
  lat: number = NaN;
  lon: number = NaN;
}

export class UpdateLocationInput {
  id: LOCATION_ID = NaN;
  client_id: CLIENT_ID = NaN;
  name?: string = '';
  display_name?: string = '';
  description?: string = '';
  address?: string = '';
  entrances?: number = NaN;
  lat?: number = NaN;
  lon?: number = NaN;
}

export class EventLocationResponse {
  id: LOCATION_ID = NaN;
  event_id?: EVENT_ID= NaN;
  name: string='';
  display_name: string = '';
  description: string='';
  address: string='';
  lat: number = NaN;
  lon: number = NaN;
}

export class EventUpdateLocation {
  name: string='';
  display_name: string = '';
  description: string='';
  address: string='';
  lat: number = NaN;
  lon: number = NaN;
}



